export default __webpack_public_path__ + "static/media/656.32f85677.png";